import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, signInAnonymously, connectAuthEmulator, onAuthStateChanged } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDoa6rnk5YBsgNP7redUsvbi72rGMFGtPo",
  authDomain: "cheerzone-5eb66.firebaseapp.com",
  projectId: "cheerzone-5eb66",
  storageBucket: "cheerzone-5eb66.firebasestorage.app",
  messagingSenderId: "248225192430",
  appId: "1:248225192430:web:b43f85c4723946fb7196ff",
  measurementId: "G-CML4BHQ1Q7"
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

if (process.env.NODE_ENV === 'development') {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectFirestoreEmulator(db, 'localhost', 1200);
  connectStorageEmulator(storage, 'localhost', 9199);
}

await new Promise((resolve) => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    unsubscribe();
    if (!user) {
      signInAnonymously(auth).then(resolve).catch(resolve);
    } else {
      resolve();
    }
  });
});
